import { Card } from '../ui/card';
import { formatCurrency } from './utils';

export function SummaryCard({ title, amount, icon: Icon, gradient, isCount = false }) {
  const displayValue = isCount ? amount : formatCurrency(amount);
  // Use smaller text for large values to prevent overflow
  const isLargeValue = displayValue && displayValue.toString().length > 12;
  
  return (
    <Card className={`p-4 sm:p-5 border-0 rounded-2xl shadow-lg ${gradient} overflow-hidden`}>
      <div className="flex items-center gap-2 sm:gap-3 mb-2">
        <div className="p-1.5 sm:p-2 bg-white/20 rounded-lg flex-shrink-0">
          <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
        </div>
        <span className="text-xs sm:text-sm text-white/80 truncate">{title}</span>
      </div>
      <p 
        className={`font-bold text-white truncate ${isLargeValue ? 'text-base sm:text-xl' : 'text-xl sm:text-2xl'}`} 
        style={{ fontFamily: "'Manrope', sans-serif" }}
        title={displayValue}
      >
        {displayValue}
      </p>
    </Card>
  );
}
